import { Injectable } from "@angular/core";

import { DffSimpelDialog } from "@dffedb/ui";

import { LoginHjaelpRepository } from "./login-hjaelp.repository";

@Injectable({ providedIn: "root" })
export class LoginHjaelpService {
    constructor(private readonly dialog: DffSimpelDialog, private readonly repository: LoginHjaelpRepository) {}

    public async visLoginHjaelpDialog(): Promise<void> {
        const indstillinger = await this.repository.hentIndstillinger().toPromise();
        await this.dialog.openOk(indstillinger.overskrift, indstillinger.indhold, { maxWidth: 400 });
    }
}
